/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type NexonAnalyticsRequest = {
    period: NexonAnalyticsRequest.period;
    interval: NexonAnalyticsRequest.interval;
    from?: string;
    to?: string;
};

export namespace NexonAnalyticsRequest {

    export enum period {
        D7 = 'D7',
        M1 = 'M1',
        M6 = 'M6',
        YTD = 'YTD',
        Y1 = 'Y1',
        ALL = 'ALL',
    }

    export enum interval {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }


}

